<template>
    <v-dialog
      v-model="showDialogMap"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-card class="dialog-map">
        <v-toolbar dark color="black">
          <div class="img-floor">
            <v-img :src="getImgFloor" width="50" v-if="currentShop !== null"></v-img>
          </div>
          
          <v-spacer ></v-spacer>
          <v-toolbar-title>КАРТА ЭТАЖЕЙ</v-toolbar-title>
          <v-spacer ></v-spacer>
          <v-btn icon dark @click="showDialogMap=false">
            <v-icon>mdi-close</v-icon>
          </v-btn>          

        </v-toolbar>

<!--         <v-card-title class="headline head-map-dialog pa-0">
          <v-row justify="space-between" align="center" class="ma-0 pa-0">
            <v-col cols="2">
               <v-img :src="getImgFloor" width="50" v-if="currentShop !== null"></v-img>
            </v-col>
            <v-col cols="8" class="white--text">
               КАРТА ЭТАЖЕЙ
            </v-col>
            <v-col cols="2" class="d-flex justify-end">
                <v-btn text color="white" @click="showDialogMap=false">X</v-btn>
            </v-col>
          </v-row>
        </v-card-title> -->


        <SingleMapPage :idShop="selectIDShop" />


      </v-card>
    </v-dialog>
  
</template>

<script>


import SingleMapPage from '@/components/SingleMapPage'
export default {
  name: 'SelectMapDialog',
  props: ['selectIDShop' , 'getImgFloor'],
    components: {
      SingleMapPage
    },
  data: () => ({
      imgF1: require('@/assets/1_floor.jpg'),
      imgF2: require('@/assets/2_floor.jpg'),
      imgF3: require('@/assets/3_floor.jpg'),
  }),
  computed:{
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },    
        showDialogMap: {
          get () {
            if(DEBUG) console.log('this.$store.state.category :', this.$store.state.app.showDialogMap);
            return this.$store.state.app.showDialogMap;
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('setShowDialogMap', val)
          }
        },
      currentShop: {
          get () {
            return this.$store.state.shops.currentShop;
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('setCurrentShop', val)
          }
        },

  },
  methods:{

  },
};
</script>
<style scoped>

.img-floor{
  width: 50px;
}

</style>